import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/SourdoughCta.module.css';

const SourdoughCta = ({ title, text, linkLabel, to }) => (
  <section className={styles.section} aria-labelledby="sourdough-cta-title">
    <div>
      <p className={styles.label}>Sourdough guide</p>
      <h2 id="sourdough-cta-title">{title}</h2>
      <p className={styles.text}>{text}</p>
    </div>
    <Link className={styles.link} to={to}>{linkLabel}</Link>
  </section>
);

SourdoughCta.defaultProps = {
  title: '',
  text: '',
  linkLabel: 'Read more',
  to: '/Sourdough',
};

export default SourdoughCta;
